import React from 'react';

export default function Header() {
  return (
    <header className="app-header">
      <div className="header-inner">
        <div className="header-brand" style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <img
            src="/krona-logo.png"
            alt="Krona Dentistry"
            style={{ height: 44, width: 'auto', display: 'block' }}
          />
          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.15 }}>
            <div
              style={{
                fontFamily: "'Arial Black', 'Helvetica Neue', Arial, sans-serif",
                fontWeight: 900,
                fontSize: 22,
                color: '#ffffff',
                letterSpacing: 0.3,
              }}
            >
              Krona Dentistry
            </div>
            <div
              style={{
                fontSize: 10,
                color: 'rgba(255,255,255,0.62)',
                letterSpacing: 0.6,
                textTransform: 'uppercase',
                marginTop: 3,
              }}
            >
              Powered by Odyssey Solutions
            </div>
          </div>
        </div>
        <div className="header-badge">HIPAA Compliance Training Portal</div>
      </div>
    </header>
  );
}
